import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d02f972")

_pushScopeId("data-v-4d02f972")
const _hoisted_1 = { id: "textEditor" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Text", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"10pt"} }, [
  /*#__PURE__*/_createTextVNode(" You can change the color of words by using minecraft color codes "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("(e.g. "),
  /*#__PURE__*/_createVNode("i", { style: {"font-family":"'Courier New', Courier, monospace"} }, "§aTest"),
  /*#__PURE__*/_createTextVNode(" for green). ")
], -1)
const _hoisted_5 = { class: "settings-row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Contains placeholders", -1)
const _hoisted_7 = {
  key: 0,
  class: "settings-row"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Preview Text", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Style", -1)
const _hoisted_11 = { class: "settings-row" }
const _hoisted_12 = { class: "alignOptions" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "label heading" }, "Position", -1)
const _hoisted_14 = { class: "settings-row" }
const _hoisted_15 = { class: "input-box" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_18 = { class: "input-box" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_color_input = _resolveComponent("color-input")
  const _component_font_editor = _resolveComponent("font-editor")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_color_input, {
      color: _ctx.component.color,
      "onUpdate:color": _cache[1] || (_cache[1] = $event => (_ctx.component.color = $event))
    }, null, 8, ["color"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("textarea", {
        rows: 5,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.component.text = $event))
      }, null, 512), [
        [_vModelText, _ctx.component.text]
      ])
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.component.placeholder = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.component.placeholder]
      ])
    ]),
    (_ctx.component.placeholder)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createVNode("textarea", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.component.previewText = $event))
          }, null, 512), [
            [_vModelText, _ctx.component.previewText]
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_9,
    _hoisted_10,
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("i", {
          class: ["material-icons", _ctx.component.alignment == 0 ? 'active' : ''],
          onClick: _cache[5] || (_cache[5] = $event => (_ctx.component.alignment = 0))
        }, " format_align_left ", 2),
        _createVNode("i", {
          class: ["material-icons", _ctx.component.alignment == 1 ? 'active' : ''],
          onClick: _cache[6] || (_cache[6] = $event => (_ctx.component.alignment = 1))
        }, " format_align_center ", 2),
        _createVNode("i", {
          class: ["material-icons", _ctx.component.alignment == 2 ? 'active' : ''],
          onClick: _cache[7] || (_cache[7] = $event => (_ctx.component.alignment = 2))
        }, " format_align_right ", 2)
      ])
    ]),
    _createVNode(_component_font_editor, {
      font: _ctx.component.font,
      "onUpdate:font": _cache[8] || (_cache[8] = $event => (_ctx.component.font = $event)),
      size: _ctx.component.size,
      "onUpdate:size": _cache[9] || (_cache[9] = $event => (_ctx.component.size = $event))
    }, null, 8, ["font", "size"]),
    _hoisted_13,
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.component.x = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.x,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_16,
        _hoisted_17
      ]),
      _createVNode("div", _hoisted_18, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.component.y = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.y,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_19,
        _hoisted_20
      ])
    ])
  ]))
})